/* eslint-disable react-refresh/only-export-components */

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CertificationsTab } from '@/app/(client)/network/-components/companyProfileTabs/certifications/CertificationsTab';
import { useCompanyDetail } from '@/app/(client)/network/-hooks/useCompanyDetail';
import { useSessionStore } from '@/store/sessionStore';

const searchSchema = z.object({
  page: z.number().int().min(1).optional(),
  limit: z.number().int().min(10).max(500).optional(),
  sort: z.string().optional(),
  filters: z.record(z.array(z.string())).optional(),
  dialog: z
    .enum(['create-certification-manual', 'create-certification-ai'])
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/claims',
)({
  validateSearch: searchSchema,
  component: ClaimsRoute,
});

function ClaimsRoute() {
  const { companyId } = Route.useParams();
  const { data: company } = useCompanyDetail(companyId);
  const user = useSessionStore(s => s.user);
  const isOwnCompany = user?.companyId === (company?.forCompanyId ?? companyId);
  const companyName =
    (company?.data?.display_name?.value as string | undefined) ??
    (company?.data?.official_name?.value as string | undefined) ??
    companyId;
  return (
    <CertificationsTab
      companyId={companyId}
      isOwnCompany={isOwnCompany}
      companyName={companyName}
    />
  );
}
